import { ROLES, checkAccessToSuperset } from '~/utils/role-utils'
import { type User } from '~/utils/types/user'

import { type MenuTab } from '../types/menu'

export const SUPERSET_URL = 'https://superset.povertystoplight.org'

const SIDEBAR_EXCLUDED_ITEMS = new Set([
  'editFamily',
  'editFamilyImages',
  'organizationEdit',
  'offline-maps',
  'priorities',
  'detail',
  'support',
  'survey-builder',
  'achievements',
])

export function isSidebarItemVisible(item: string) {
  return !SIDEBAR_EXCLUDED_ITEMS.has(item)
}

export function getMenuItemPath(item: string, user: User) {
  if (item === 'projects') {
    return `/hubs/${user.hub?.id}/organizations/${user.organization?.id}/projects`
  }

  if (item === 'organizations') {
    return `/hubs/${user.hub?.id}/organizations`
  }

  return `/${item}`
}

export function getSupersetHref(user: Pick<User, 'token'>) {
  return `${SUPERSET_URL}/auth/token-login?token=${user.token}&next=/superset/welcome/`
}

export function getExternalMenuItemHref(
  item: string,
  user: Pick<User, 'token'>,
) {
  return item === 'superset' ? getSupersetHref(user) : null
}

export function getMenuLabelKey(item: string, user?: Pick<User, 'role'>) {
  if (item === 'families' && user?.role === ROLES.FAMILY) {
    return 'views.familyProfile.profile'
  }

  return item === 'homepage' ? 'homepage.whatsNew' : `views.toolbar.${item}`
}

export function addSupersetTab(tabs: MenuTab[], user: User | null): MenuTab[] {
  if (
    !checkAccessToSuperset(user) ||
    tabs.some(
      tab => tab.item === 'superset' || tab.options?.includes('superset'),
    )
  ) {
    return tabs
  }

  const analyticsTabIndex = tabs.findIndex(tab => tab.item === 'analytics')

  if (analyticsTabIndex === -1) {
    return [...tabs, { item: 'superset', shouldShowOnHeader: true }]
  }

  return tabs.map((tab, index) => {
    if (index !== analyticsTabIndex) return tab

    return {
      ...tab,
      options: [...(tab.options ?? []), 'superset'],
    }
  })
}
